var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 75 75",
    id: "svg5",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(0,74.999998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "translate(77.454706)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26409",
    transform: "matrix(1.072317,0,0,1.0705546,-36.063757,-65.496064)",
    style: {
      strokeWidth: 0.933327
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 4.93886,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M -3.9484487,7.110151e-6 -23.89689,20.152833 V 50.382071 H 15.999993 V 20.152833 Z",
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 4.93886,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M 5.7978456,50.382071 V 31.488797 h -12.467776 v 18.893274 z",
    id: "path10760"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    transform: "translate(197.75273)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26399",
    transform: "translate(-145.63822,-63.867057)",
    style: {
      fill: "#8c8c8c",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M -39.456765,7.110151e-6 H 10.414339 V 12.595523 H -4.5469927 1.6868953 V 31.488797 H -30.729322 V 12.595523 h 6.233888 -14.961331 z",
    id: "path13008"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.29167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m -8.2535628,20.466408 v 18.893274 l -7.4806652,7.55731 7.4806652,7.557309 7.48066565,-7.557309 -7.48066565,-7.55731 z",
    id: "path13010"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(55.752423)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26405",
    transform: "matrix(0.93159567,0,0,0.93308465,-83.754683,-63.678183)",
    style: {
      strokeWidth: 1.07257
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.67569,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m -140.81062,0.02619241 h 43.003288 V 42.959303 l -10.750828,10.733278 h -32.25246 z",
    id: "path15366",
    transform: "translate(189.33373)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.48486,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "path15420",
    cx: -97.751869,
    cy: 67.111801,
    rx: 10.686455,
    ry: 10.67546,
    transform: "matrix(0.90314476,0.42933615,-0.43048092,0.90259966,189.33373,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.67569,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m -127.36604,26.24412 c -0.83986,1.760961 0.46813,1.515107 -0.41587,3.36867 -0.88402,1.853561 -1.54338,0.739388 -2.35721,2.445802 -0.81386,1.706415 0.53568,1.373421 -0.4159,3.368669 -0.95159,1.995244 -1.45243,0.548718 -2.35721,2.445803 -0.9048,1.897083 1.78727,3.887784 4.15744,5.014517 2.37019,1.126736 5.64508,1.895355 6.51984,0.06124 0.87474,-1.834117 -0.38741,-1.684374 0.41587,-3.368671 0.80331,-1.684295 1.46937,-0.584206 2.35722,-2.445801 0.88787,-1.861596 -0.4851,-1.47951 0.41588,-3.36867 0.90101,-1.889159 1.36136,-0.394148 2.35722,-2.445802 0.99588,-2.051644 -2.54898,-2.560175 -4.80809,-3.650301 -2.25912,-1.090123 -5.02935,-3.186418 -5.8692,-1.425458 z",
    id: "path15424",
    transform: "translate(189.33373)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.67569,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M -110.96175,53.664468 V 40.784535 h 12.90097",
    id: "path16878",
    transform: "translate(189.33373)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    transform: "translate(55.004068)",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26395",
    transform: "matrix(0.9015395,0,0,0.9015395,-235.86592,-62.763106)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3f4444",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 6.53287,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 223.57534,0.62049882 c 0,0 -5.09994,11.58247818 -6.57251,20.35365518 -0.0124,0.07359 -0.0245,0.146979 -0.0363,0.220163 -0.52954,3.273477 -0.53794,6.134038 0.43602,7.820996 3.59112,6.219993 24.69114,19.190935 24.69114,19.190935 0,0 21.12167,-13.008413 24.69115,-19.190935 3.56948,-6.182521 -6.17278,-28.39481418 -6.17278,-28.39481418 L 254.43927,16.669742 h -24.69114 z",
    id: "path20887"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d3d3d3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.53287,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 242.0937,37.657213 -11.11102,8.641901 c 0,0 7.04242,5.937857 11.11102,5.925874 4.06859,-0.01198 11.11101,-5.925874 11.11101,-5.925874 z",
    id: "path20997"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.53287,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 213.81475,20.252419 c 6.20622,-1.796537 28.27895,17.404794 28.27895,17.404794 l -11.11102,8.641901 c 0,0 -24.15163,-15.444096 -17.16793,-26.046695 z",
    id: "path20919"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.53287,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 270.36252,20.252419 c -6.20622,-1.796537 -28.27894,17.404794 -28.27894,17.404794 l 11.11101,8.641901 c 0,0 24.15163,-15.444096 17.16793,-26.046695 z",
    id: "path24120"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer7",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g29745",
    transform: "matrix(1.2949012,0,0,1.2949012,33.642157,-61.718301)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#3f4444",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    d: "m -13.636197,5.5302 3.6317,-5.53080876716 L 14.363802,23.530201 l -4.9999996,7 h -8 l -5,5 v -5 h -9.9999994 z",
    id: "path26493-1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#8c8c8c",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 5.292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m -10,0 h 28 v 18 l -5,7 H 5 l -5,5 v -5 h -10 z",
    id: "path26493"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      fill: "#c2c2c2",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 3.43958,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 0,7 v 8",
    id: "path28796"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      fill: "#c2c2c2",
      fillOpacity: 1,
      stroke: "#3f4444",
      strokeWidth: 3.43958,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      stopColor: "#000000"
    },
    d: "m 9,7 v 8",
    id: "path28796-0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.67700ea1d17c82b20cda3d7ff139fadc.svg";
export { ForwardRef as ReactComponent };